import family from './family';
import dual from './dual';

export default {
  family: family,
  dual: dual,
};
